import { useState, useEffect } from 'react';

/**
 * Determines if a specific matchMedia breakpoint is matched
 * @param {string} query
 * @returns boolean
 */
const useMatchMediaQuery = (query) => {
  if (typeof window === 'undefined' || !query) {
    // Returning an empty fragment here vs. boolean false fixes a hydration issue
    return <></>;
  }

  const matchMediaQuery = window.matchMedia(query);
  const [match, setMatch] = useState(matchMediaQuery.matches);

  function determineMatch() {
    setMatch(matchMediaQuery.matches);
  }

  // Set up event listeners only on first mount
  useEffect(() => {
    try {
      matchMediaQuery.addEventListener('change', determineMatch);
    } catch (error) {
      // TODO remove this
      // addEventListener is not supported in older Safari, but addListener is.
      matchMediaQuery.addListener(determineMatch);
    }

    return () => {
      try {
        matchMediaQuery.removeEventListener('change', determineMatch);
      } catch (error) {
        // TODO remove this
        // removeEventListener is not supported in older version of Safari, but removeListener is.
        matchMediaQuery.removeListener(determineMatch);
      }
    };
  }, []);

  return match;
};

export default useMatchMediaQuery;
